/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OrInputs */

const en_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const nl_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {OrInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const or = /** @type {((inputs?: OrInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OrInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_or(inputs)
	return en_or(inputs)
});